import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { FedExLegalAgreementConfig } from "@redotech/redo-web/arbiter-components/oms/fedex-mfa-modal";
import { LegalAgreementModal } from "@redotech/redo-web/legal-agreement-modal";
import { memo, useEffect } from "react";
import { RedoOutboundLabelsRpcClientContext } from "../outbound-labels-rpc-client";

interface FedexAgreementModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccepted: () => void;
}

export const FedexAgreementModal = memo(function FedexAgreementModal({
  isOpen,
  onClose,
  onAccepted,
}: FedexAgreementModalProps) {
  const outboundLabelsRpcClient = useRequiredContext(
    RedoOutboundLabelsRpcClientContext,
  );

  const handleSubmit = useHandler(async () => {
    await outboundLabelsRpcClient.acceptFedexAgreement({});
    onAccepted();
    onClose();
  });

  // Pre fetch the image on mount to improve load time when the modal is opened
  useEffect(() => {
    void fetch(FedExLegalAgreementConfig.imageUrl);
  }, []);

  return (
    <LegalAgreementModal
      description={FedExLegalAgreementConfig.description}
      imageUrl={FedExLegalAgreementConfig.imageUrl}
      isOpen={isOpen}
      onAccepted={handleSubmit}
      onClose={onClose}
      requireScroll={FedExLegalAgreementConfig.requireScroll}
      title={FedExLegalAgreementConfig.title}
    />
  );
});
